module.exports = "/_next/static/images/strategic-planning-training-header-578b7bbc74767d8a0ade0f4c6a6c882e.webp";